module.exports = __webpack_public_path__ + "img/welcome-new.53c6a7c1.png";